import { useState } from 'react';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import { Alert, Button, Stack, TextField } from '@mui/material';
import AuthShell from '../components/AuthShell';
import { api, apiErrorMessage } from '../api/client';

export default function ResetPasswordPage() {
  const { token = '' } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await api.post('/auth/reset-password', { token, new_password: password });
      navigate('/login', { replace: true });
    } catch (err) {
      setError(apiErrorMessage(err, 'Could not reset password.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Reset password"
      subtitle="Pick a new password to log back in."
      footer={<RouterLink to="/login" aria-label="Back to sign in">Back to sign in</RouterLink>}
    >
      <form onSubmit={onSubmit} aria-label="Reset password form">
        <Stack spacing={2}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="New password (min 8 chars)"
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            inputProps={{ 'aria-label': 'New password' }}
          />
          <TextField
            label="Confirm password"
            type="password"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            inputProps={{ 'aria-label': 'Confirm password' }}
          />
          <Button type="submit" variant="contained" size="large" disabled={busy} aria-label="Reset password">
            {busy ? 'Saving…' : 'Reset password'}
          </Button>
        </Stack>
      </form>
    </AuthShell>
  );
}
